export interface ClaimAppDownloadBonusResponse {
  granted: boolean;
  freeCredits: number;
  message: string;
}

// One-time call: claims native app download bonus (adds APP_DOWNLOAD_BONUS_CREDITS to bonusFreeCredits)
// Backend is idempotent — safe to call multiple times, bonus granted at most once per user
export const claimAppDownloadBonus = async (
  accessAuthToken: string,
): Promise<ClaimAppDownloadBonusResponse> => {
  const url = `${process.env.REACT_APP_BACKEND_URL}/users/claim-app-bonus`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessAuthToken}`,
      "Content-Type": "application/json",
    },
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error(`Failed to claim app download bonus: ${response.status}`);
  }

  return response.json();
};
